import { ItemRestraints } from '@core/shared/restraints';
export class QuestionRestraints extends ItemRestraints {
  canCreateItem(item) {
    return this.requireRole('ADMINISTRATOR');
  }
  canToggleItem(item) {
    return this.requireRole('ADMINISTRATOR');
  }
  canUpdateItem(item, oldItem) {
    return this.requireRole('ADMINISTRATOR');
  }
  canRemoveItem(item) {
    return this.requireRole('ADMINISTRATOR');
  }
}